import React from "react"
import styled, {css} from "styled-components"

import {useTheme} from "../global/useTheme"
import {SpacingProps as GlobalSpacingProps, spacingCss} from "../global/css"

interface LineProps {
  dotted?: boolean
  solid?: boolean
}

interface SpacingProps extends GlobalSpacingProps {
  flush?: boolean
}

interface HRProps extends LineProps, SpacingProps {}

const getLine = (props: LineProps) => {
  const theme = useTheme()
  if (props.dotted) {
    return `border-top: 1px dotted ${theme.colors.greys.light};`
  } else if (props.solid) {
    return `
      border-top: 1px solid ${theme.colors.greys.mediumDark};
    `
  }
  return `border-top: 1px solid ${theme.colors.greys.light};`
}

export const StyledHr = styled.hr<HRProps>`
  ${({flush}) =>
    flush &&
    css`
      margin: 0;
      padding: 0;
    `}
  width: 100%;
  height: 1px;
  ${(props) => getLine(props)}
  ${spacingCss}
`

export default function Hr(props: HRProps) {
  return <StyledHr {...props} aria-hidden="true" />
}
